import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  section: {
    marginBottom: 16,
    width: "100%"
  },
  header: {
    backgroundColor: "#2c67bf",
    color: "#fff",
    fontSize: 16,
    borderTopRightRadius: 3,
    borderTopLeftRadius: 3,

    borderBottomRightRadius: 3,
    borderBottomLeftRadius: 3,

    borderBottomColor: "#000",
    padding: 4,
    paddingBottom: 6,
    lineHeight: 1,
    fontWeight: 700,
    fontFamily: "Montserrat"
  },
  body: {
    paddingTop: 12,
    paddingBottom: 0
  }
});

export const Section = ({ name, children }) => {
  return (
    <View style={styles.section}>
      <View style={styles.header}>
        <Text>{name.toUpperCase()}</Text>
      </View>

      <View style={styles.body}>{children}</View>
    </View>
  );
};
